(() => {
  const getPopup = (target) => target?.closest?.('[data-header-search-popup]');

  const openPopup = (popup, focusInput = false) => {
    if (!popup) return;

    const input = popup.querySelector('[data-header-search-input]');
    if (!input) return;

    popup.classList.add('is-open');
    popup.setAttribute('data-header-search-open', 'true');
    popup.removeAttribute('data-header-search-closed');
    input.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('header-search-popup-open');

    if (focusInput && document.activeElement !== input) {
      requestAnimationFrame(() => input.focus({ preventScroll: true }));
    }
  };

  const scheduleOpenPopup = (popup, focusInput = false) => {
    openPopup(popup, focusInput);

    // Dawn's native predictive-search can close itself after focus changes.
    // Re-applying shortly after the interaction keeps the custom panel reusable after closing it.
    window.setTimeout(() => openPopup(popup, false), 0);
    window.setTimeout(() => openPopup(popup, false), 80);
  };

  const closePopup = (popup) => {
    if (!popup) return;

    const input = popup.querySelector('[data-header-search-input]');

    popup.classList.remove('is-open');
    popup.removeAttribute('data-header-search-open');
    popup.removeAttribute('data-header-search-closed');
    popup.removeAttribute('open');
    popup.removeAttribute('loading');
    document.documentElement.classList.remove('header-search-popup-open');

    if (input) {
      input.setAttribute('aria-expanded', 'false');
    }

    popup.close?.(false);

    if (document.activeElement && popup.contains(document.activeElement)) {
      document.activeElement.blur();
    }

    window.setTimeout(() => {
      popup.removeAttribute('open');
      popup.removeAttribute('loading');
    }, 0);
  };

  const openFromInteraction = (event) => {
    const popup = getPopup(event.target);

    if (!popup || event.target.closest('[data-header-search-close]')) return;

    if (
      event.target.closest('[data-header-search-input]') ||
      event.target.closest('.header-predictive-search__field') ||
      event.target.closest('[data-header-search-submit]')
    ) {
      scheduleOpenPopup(popup, true);
    }
  };

  document.addEventListener('pointerdown', openFromInteraction, true);
  document.addEventListener('mousedown', openFromInteraction, true);
  document.addEventListener('touchstart', openFromInteraction, true);
  document.addEventListener('pointerup', openFromInteraction, true);
  document.addEventListener('mouseup', openFromInteraction, true);
  document.addEventListener('touchend', openFromInteraction, true);
  document.addEventListener('click', openFromInteraction, true);

  document.addEventListener('focusin', (event) => {
    const popup = getPopup(event.target);
    if (!popup || !event.target.matches('[data-header-search-input]')) return;

    scheduleOpenPopup(popup, false);
  });

  document.addEventListener('input', (event) => {
    const popup = getPopup(event.target);
    if (!popup || !event.target.matches('[data-header-search-input]')) return;

    scheduleOpenPopup(popup, false);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-header-search-submit]')) {
      event.preventDefault();
      openPopup(getPopup(event.target), true);
      return;
    }

    if (event.target.closest('[data-header-search-close]')) {
      event.preventDefault();
      event.stopPropagation();
      closePopup(getPopup(event.target));
      return;
    }

    document.querySelectorAll('[data-header-search-popup].is-open').forEach((popup) => {
      const clickPath = event.composedPath?.() || [];
      const clickedInside = clickPath.includes(popup) || popup.contains(event.target);

      if (!clickedInside) closePopup(popup);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-header-search-popup].is-open').forEach((popup) => {
      closePopup(popup);
    });
  });
})();
